<template>
    <li class="menu-dropdown classic-menu-dropdown" :class="{ active }" @click="$emit('click', $event)">
        <router-link v-if="to" :to="{ name: to, params: params }">
            <slot></slot>
        </router-link>
        <a v-if="href" :href="href" :target="blank ? '_blank' : '_self'"><slot></slot></a>
    </li>
</template>

<script>
export default {
    name: "Li",
    props: {
        to: {
            type: String,
            default: null
        },
        href: {
            type: String,
            default: null
        },
        params: {
            type: Object,
            default: () => {}
        },
        blank: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        active() {
            return this.$route.name === this.to;
        }
    }
}
</script>

<style scoped>

</style>
